// Ekranın sağ altında kısa bildirim (React'e bağlı değil; her yerden çağrılabilir).
// toast('Kaydedildi') · toast('Silinemedi: …', 'error')
let box;
export default function toast(message, type = 'info', ms = 4500) {
  if (typeof document === 'undefined' || !message) return;
  if (!box) {
    box = document.createElement('div');
    box.className = 'toasts';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    document.body.appendChild(box);
  }
  const el = document.createElement('div');
  el.className = `toast toast--${type}`;
  el.textContent = message;
  el.onclick = () => el.remove();
  box.appendChild(el);
  setTimeout(() => el.remove(), ms);
}
